import cn from "classnames"
import React from "react"

import { useThemeContext } from "~/components/Theme/Theme"

import styles from "./index.module.css"

type ArrowProps = {
  className?: string
  inCircle?: boolean
  direction: "right" | "left"
  href?: string
}

export const Arrow = React.forwardRef<HTMLDivElement, ArrowProps>(
  ({ inCircle, direction, className, href }, ref) => {
    const { theme } = useThemeContext()
    const clsName = cn(className, {
      [styles.Dark]: inCircle && theme === "dark",
      [styles.Light]: inCircle && theme === "light",
      [styles.Simple]: !inCircle,
      [styles.DirectionLeft]: direction === "left",
    })

    const Component = href ? "a" : ("div" as React.ElementType<any>)

    return (
      <Component ref={ref} className={clsName} href={href}>
        <div className={styles.Icon}>
          <svg fill="none" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.719 1.12l6.8 6.8-6.8 6.8" />
          </svg>
        </div>
      </Component>
    )
  },
)
